import React from "react";
import Navbar from "./components/Navbar";
import Services from "./components/Services";

function App() {
  return (
    <div>
      <Navbar></Navbar>
      <div>Hi</div>
    </div>
  );
}

export default App;
